import { CategoryData } from '../../../../types/types';

export const temps: CategoryData = {
  'Altine (Lundi)': { translation: 'Lundi', translationEn: 'Monday', illustration: '1️⃣' },
  'Talaata (Mardi)': { translation: 'Mardi', translationEn: 'Tuesday', illustration: '2️⃣' },
  'Àllarba (Mercredi)': { translation: 'Mercredi', translationEn: 'Wednesday', illustration: '3️⃣' },
  'Alxames (Jeudi)': { translation: 'Jeudi', translationEn: 'Thursday', illustration: '4️⃣' },
  'Àjjuma (Vendredi)': { translation: 'Vendredi', translationEn: 'Friday', illustration: '5️⃣' },
  'Gaawu (Samedi)': { translation: 'Samedi', translationEn: 'Saturday', illustration: '6️⃣' },
  'Dibéer (Dimanche)': { translation: 'Dimanche', translationEn: 'Sunday', illustration: '7️⃣' },
  'Demb (Hier)': { translation: 'Hier', translationEn: 'Yesterday', audio: 'Wf-demb', illustration: '⬅️' },
  'Bés (Jour)': { translation: 'Jour', translationEn: 'Day', illustration: '📆' },
  'Suba (Matin)': { translation: 'Matin', translationEn: 'Morning', audio: 'Wf-suba', illustration: '🌅' },
  'Ngoon (Après-midi)': { translation: 'Après-midi', translationEn: 'Afternoon', illustration: '🌇' },
  'Guddi (Nuit)': { translation: 'Nuit', translationEn: 'Night', audio: 'Wf-guddi', illustration: '🌙' },
  'Weer (Mois)': { translation: 'Mois', translationEn: 'Month', audio: 'Wf-weer', illustration: '📅' },
  'At (Année)': { translation: 'Année', translationEn: 'Year', illustration: '🗓️' },
};

export default temps;
